<script setup lang="ts">
import { computed, defineEmits, defineProps } from 'vue'

const props = defineProps({
  filteredItems: { type: Array, required: true },
  selectedItems: { type: Array, required: true },
  canAddItem: { type: Boolean, required: false, default: true },
  canChangeItem: { type: Boolean, required: false, default: true },
  canDeleteItem: { type: Boolean, required: false, default: true },
  showDeleteButton: { type: Boolean, required: false, default: false }
})

const emit = defineEmits(['updateSelectedItems', 'deleteSelectedItems'])

const selectAll = computed({
  get() {
    return props.filteredItems.every((item) => props.selectedItems.includes(item))
  },
  set: (value) => {
    emit('updateSelectedItems', value, props.filteredItems)
  }
})

const disabled = computed(() => {
  return !props.selectedItems || !props.selectedItems.length
})

const btnColor = computed(() => {
  return disabled.value ? 'revert' : 'primary'
})
</script>

<template>
  <v-row justify="center" align="center" class="pa-4">
    <v-col cols="12" md="6" class="d-flex justify-start">
      <v-checkbox
        v-if="(canAddItem || canChangeItem || canDeleteItem) && props.filteredItems?.length"
        v-model="selectAll"
        label="Select all"
        density="compact"
        hide-details
      />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-end">
      <v-btn
        v-if="canDeleteItem && showDeleteButton"
        class="text-none my-1 mx-2"
        variant="tonal"
        prepend-icon="mdi-trash-can-outline"
        :color="btnColor"
        :disabled="disabled"
        @click.stop="() => emit('deleteSelectedItems')"
      >
        Delete
      </v-btn>
    </v-col>
  </v-row>
</template>

<style scoped></style>
